<script>
  import ListaEventos from './FormListaEventos.vue';
  import { datepicker, checkbox } from 'vue-strap';
  import radio from '~componentes/Radio.vue';
  import projetoServico from '~modulos/projeto/servico';
  import solicitacaoContratacaoPessoalServico from '../../servico';
  import converterMoeda from '~js/converter-moeda';
  
  export default {
    components: { datepicker, checkbox, ListaEventos, radio },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        evento: this.camposEvento(),
        usuario: this.$storage.usuario(),
        desabilitaCampo: false,
        eventos: [],
        configuracao: this.$storage.configuracao(),

        textoDetalhamentoEvento: '',
        valorMinimo: 0.0,
        valorMaximo: 0.0,
      }
    },
    methods: {
      nl2br(str) {
        var breakTag = '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
      },
      camposEvento() {
        return {
          idSolicitacaoContratacaoPessoalEventos: null,
          idSolicitacaoContratacaoPessoal: null,
          idSolicitacaoContratacaoPessoalEvento: null,
          valorEstimado: null,
          observacao: '',
          solicitacaoContratacaoPessoalEvento: {
            idSolicitacaoContratacaoPessoalEvento: null,
            descricao: '',
            valorSugerido: null,
            valorMinimo: null,
            valorMaximo: null,
            obrigatorioCLT: null,
            obrigatorioEstagiario: null,
            detalhamento: '',
          },
        }
      },
      listaDeEventos(auxTipoSolicitacao) {
        this.evento.idSolicitacaoContratacaoPessoalEvento = '';
        this.eventos = [];

        return solicitacaoContratacaoPessoalServico
          .eventos(auxTipoSolicitacao)
          .then(eventos => {
            this.eventos = eventos;
          });
      },
      validarDados(valido) {
        if (!valido) return false;

        const evnt = this.eventoSelecionado(this.evento.idSolicitacaoContratacaoPessoalEvento)

        if (evnt) {
          if ((evnt.valorMinimo == 0) || (evnt.valorMaximo == 0)) return valido;
        }
        else return valido;

        let msgErro = "";

        const valorEstimado = this.$options.filters.formatarNumero(this.evento.valorEstimado, true);

        if ((evnt.valorMinimo > 0) && (evnt.valorMaximo > 0)) {
          if ((valorEstimado < evnt.valorMinimo) || (valorEstimado > evnt.valorMaximo)) {
            msgErro = 'O valor tem que ser maior ou igual a ' + this.$options.filters.formatarNumero(evnt.valorMinimo) +
              ' e menor ou igual a ' + this.$options.filters.formatarNumero(evnt.valorMaximo)
          }
        }
        else {
          if (valorEstimado < evnt.valorMinimo) {
            msgErro = 'O valor tem que ser maior ou igual a ' + this.$options.filters.formatarNumero(evnt.valorMinimo)
          }

          if (valorEstimado > evnt.valorMaximo) {
            msgErro = 'O valor tem que ser menor ou igual a ' + this.$options.filters.formatarNumero(evnt.valorMaximo)
          }
        }

        if (msgErro) {
          this.$swal(
            '',
            msgErro,
            'info'
          );

          throw new Error("validacao");
          return false;
        }
        else return valido;
      },
      validar() {
         this.$validator
          .validateAll()
          .then(valido => {

            return valido;
          })
          .then(this.validarDados)
          .then(valido => {
            if (valido) {
              this.adicionar();
            }
          })
      },
      adicionar() {
        const copiaEvento = Object.assign(this.evento);

        copiaEvento.solicitacaoContratacaoPessoalEvento = this.eventoSelecionado(copiaEvento.idSolicitacaoContratacaoPessoalEvento);

        this.solicitacao.eventos.push(copiaEvento);

        this.evento = this.camposEvento();

        this.$validator.reset();
        this.textoDetalhamentoEvento = '';
        this.valorMinimo = 0.0
      },
      eventoSelecionado(idSolicitacaoContratacaoPessoalEvento) {
        return this.eventos.find(evento => evento.idSolicitacaoContratacaoPessoalEvento == idSolicitacaoContratacaoPessoalEvento);
      },
      selecaoBeneficio(){
        const evnt = this.eventoSelecionado(this.evento.idSolicitacaoContratacaoPessoalEvento)
        this.textoDetalhamentoEvento = '';
        this.valorMinimo = 0.0

        if (evnt) {
          if (evnt.valorSugerido > 0)
            this.evento.valorEstimado = converterMoeda.paraReal(evnt.valorSugerido);
          else
            this.evento.valorEstimado = null;

          if (evnt.valorMinimo > 0)
            this.valorMinimo = evnt.valorMinimo;

          this.textoDetalhamentoEvento = evnt.detalhamento;
        }
      },
      possuiEventosObrigatorios() {
        const eventos = this.eventosDisponiveis;

        return eventos.some(ev => (ev.obrigatorioCLT || ev.obrigatorioEstagio));
      }
    },
    mounted() {
      this.listaDeEventos(this.solicitacao.tipoSolicitacao);
    },
    computed: {
      eventosDisponiveis() {
        const idsUsados = new Set(
          this.solicitacao.eventos.map(e => e.idSolicitacaoContratacaoPessoalEvento)
        );

        return this.eventos.filter(ev => !idsUsados.has(ev.idSolicitacaoContratacaoPessoalEvento));
      },
    },
    watch: {

    }
  }
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xs-8">
        <div class="form-group required" :class="{'has-error': errors.has('evento')}">
          <label class="control-label" for="meta-etapa">Benefício</label>

          <select class="form-control"
                  id="beneficio"
                  v-model="evento.idSolicitacaoContratacaoPessoalEvento"
                  data-vv-name="evento"
                  data-vv-as="benefício"
                  v-validate="'required'"
                  @change="selecaoBeneficio">
            <option value="">Selecione...</option>
            <option :value="evento.idSolicitacaoContratacaoPessoalEvento"
                    v-for="(evento, index) in eventosDisponiveis">
              {{ `${evento.descricao}` }} {{ (evento.obrigatorioCLT || evento.obrigatorioEstagio) ? ' - Obrigatório' : '' }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('evento')">{{ errors.first('evento') }}</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group required" :class="{'has-error': errors.has('valor')}">
          <label class="control-label" for="valor">Valor estimado</label>

          <input type="text"
                 class="form-control text-right"
                 id="valor"
                 v-model="evento.valorEstimado"
                 data-vv-name="valor"
                 data-vv-as="Valor"
                 v-validate="'required'"
                 v-mascara="'moeda'">

          <p class="text-danger" v-show="errors.has('valor')">{{ errors.first('valor') }}</p>
        </div>
      </div>
    </div>

    <div class="alert alert-info" role="alert" v-if="textoDetalhamentoEvento">
      <div class="row">
        <dl class="col-xs-12">
          <dt></dt>
          <dd v-html="textoDetalhamentoEvento">
            {{ textoDetalhamentoEvento }}
          </dd>
        </dl>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'has-error': errors.has('observacao')}">
          <label class="control-label" for="observacao">Observação</label>

          <textarea class="form-control"
                    id="observacao"
                    v-model="evento.observacao"
                    data-vv-name="observacao"
                    data-vv-as="Observação"
                    v-validate="">
      </textarea>

          <p class="text-danger" v-show="errors.has('observacao')">{{ errors.first('observacao') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <button type="button" class="btn btn-success" @click="validar" id="adicionarevento">
            <i class="fa fa-plus"></i>
            Adicionar benefício
          </button>
        </div>
      </div>
    </div>

    <hr class="margin-top-10">

    <lista-eventos :eventos="solicitacao.eventos">
    </lista-eventos>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-contratacao-pessoal/componentes/compartilhado/FormEventos.vue